import { type QueryFunctionContext, useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';
import qs from 'qs';

import type { ITableSorting } from '@model/tableSorting';

import { apiClient } from '@services/apiClient';

import type {
  IAssetHealthEquipmentList,
  IUseAssetHealthEquipmentListKeys,
} from '../model/assetHealthEquipmentList';

export const assetHealthEquipmentListKey = (
  keys: IUseAssetHealthEquipmentListKeys,
): [string, Array<number> | undefined, ITableSorting, string | number | undefined] => [
  'assetHealthEquipmentList',
  keys.locationIds,
  keys.sorting,
  keys.urgency,
];

export const assetHealthEquipmentListFn = ({
  queryKey,
}: QueryFunctionContext<ReturnType<typeof assetHealthEquipmentListKey>, number>) => {
  const orderBy = queryKey[2].id ? queryKey[2].id : undefined;
  const direction = !queryKey[2].id ? undefined : queryKey[2].desc ? 'desc' : 'asc';

  const params = {
    location_ids: queryKey[1],
    sort: {
      field: orderBy,
      direction: direction,
    },
    urgency: queryKey[3] === 'all' ? undefined : queryKey[3],
  };

  return apiClient.get<{ data: IAssetHealthEquipmentList[] }>(
    `${APP_API_URL_V2}fsd/action-item/asset-health/action-items-by-equipment`,
    {
      params,
      paramsSerializer: {
        serialize: (params) => qs.stringify(params),
      },
    },
  );
};

export const useAssetHealthEquipmentListQuery = (keys: IUseAssetHealthEquipmentListKeys) => {
  return useQuery({
    queryKey: assetHealthEquipmentListKey(keys),
    queryFn: assetHealthEquipmentListFn,
    select: ({ data }: AxiosResponse<{ data: IAssetHealthEquipmentList[] }>) => {
      if (!data.data) {
        return [];
      }
      return data.data;
    },
  });
};
